import React from 'react';

const WhatMakesUsDifferent: React.FC = () => {
  const differences = [
    {
      icon: 'ri-close-circle-line',
      label: 'No guesswork',
      color: 'text-red-500'
    },
    {
      icon: 'ri-close-circle-line',
      label: 'No hype or opinions',
      color: 'text-red-500'
    },
    {
      icon: 'ri-close-circle-line',
      label: 'No beta testers needed',
      color: 'text-red-500'
    },
    {
      icon: 'ri-close-circle-line',
      label: 'Not based on downloads',
      color: 'text-red-500'
    },
    {
      icon: 'ri-close-circle-line',
      label: 'Not based on popularity',
      color: 'text-red-500'
    },
    {
      icon: 'ri-checkbox-circle-line',
      label: 'Built on structured intelligence',
      color: 'text-teal-500'
    },
    {
      icon: 'ri-checkbox-circle-line',
      label: 'Designed to remove founder bias',
      color: 'text-teal-500'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Makes Us Different
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            CrowdRounds isn't another analytics tool or user testing platform. We're something entirely new.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6">
            {differences.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 bg-gradient-to-r from-gray-50 to-white rounded-xl border border-gray-200"
              >
                <div className="flex-shrink-0">
                  <i className={`${item.icon} text-3xl ${item.color}`}></i>
                </div>
                <p className="text-lg font-semibold text-gray-900 pt-1">
                  {item.label}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center bg-gradient-to-r from-teal-50 to-teal-100 p-8 rounded-2xl border border-teal-200">
            <p className="text-xl font-bold text-gray-900 mb-2">
              The Result?
            </p>
            <p className="text-lg text-gray-700">
              Objective, actionable intelligence that helps you make confident decisions about your app's future.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatMakesUsDifferent;
